import React from 'react'
import ContactUsform from '../components/contactUs'
import CollegeAddressContact from '../components/CollegeAddressContact'

const ContactUs = () => {
  return (
    <div className='pt-[50px]'>
        {/* <ContactUsform/> */}
        <CollegeAddressContact/>

    </div>
  )
}

export default ContactUs